module.exports = __webpack_public_path__ + "9a653370c8784dea781eb427e2b892b4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KM.svg
// module id = 7bNE
// module chunks = 0